import type { ServerProvider } from "@cmmd-forge/contracts";

/**
 * Canonical provider-readiness gate for starting work.
 *
 * Cloud user VMs can execute through Forge's scoped provider proxy without a
 * provider-local login. In that case the provider reports unauthenticated but
 * its credential provenance is explicitly `proxied`.
 */
export function isServerProviderExecutable(provider: ServerProvider): boolean {
  const hasExecutionAuthority =
    provider.auth.status !== "unauthenticated" ||
    provider.auth.provenance?.credentialScope === "proxied";

  return (
    provider.enabled &&
    provider.installed &&
    provider.status === "ready" &&
    hasExecutionAuthority &&
    provider.models.length > 0
  );
}
